// 3rd Party
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { SPECIALTY } from 'common/constants';
import { MarketingButton } from 'common/styles/oc-styled-components';

// Other
import { requestFeaturesForSpecialty } from 'connect/actions';

import { selectDataClinicFeatures } from '../../connect/selectors';
import { markFeaturesWithOffered } from '../../helpers/profile-office-helpers';
import {
  FeatureList,
  FeatureName,
  ProfileSubsectionBody,
  ProfileSubsectionHeader,
  ProfileSubsectionTitle,
} from '../../profile-styled-components';

const ProfileOfficeFeatures = () => {
  const dispatch = useDispatch();
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const features = useSelector(selectDataClinicFeatures);
  const clinicFeatures = features || [];
  const orderedFeatures = _.sortBy(clinicFeatures, 'name');
  const { features: allFeatures } = useSelector(
    (state) => state.data.featuresForSpecialty,
  );

  const offeredFeatures = markFeaturesWithOffered(clinicFeatures, allFeatures);
  const orderedOfferedFeatures = _.sortBy(offeredFeatures, 'name');

  useEffect(() => {
    dispatch(requestFeaturesForSpecialty(SPECIALTY.dentist));
  }, []);

  return (
    <>
      {clinicFeatures.length > 0
        && (
          <section>
            <ProfileSubsectionHeader>
              <ProfileSubsectionTitle fontSize="24px">
                Practice Features
              </ProfileSubsectionTitle>
            </ProfileSubsectionHeader>
            <ProfileSubsectionBody>
              {showAllFeatures
                ? (
                  <FeatureList>
                    {orderedOfferedFeatures.map((feature) => (
                      <FeatureName
                        key={feature.id}
                        crossOut={!feature.offered}
                        aria-hidden={!feature.offered}
                        as="li"
                      >
                        {feature.name}
                      </FeatureName>
                    ))}
                  </FeatureList>
                )

                : (
                  <FeatureList>
                    {orderedFeatures.map((feature) => (
                      <FeatureName key={feature.id} as="li">
                        {feature.name}
                      </FeatureName>
                    ))}
                  </FeatureList>
                )}
              <MarketingButton
                type="secondary"
                shape="round"
                onClick={() => setShowAllFeatures(!showAllFeatures)}
                // The expanded version only adds crossed out features,
                // which the screen reader doesn't read
                aria-hidden
              >
                {showAllFeatures ? 'Hide' : 'View'} All Features
              </MarketingButton>
            </ProfileSubsectionBody>
          </section>
        )}
    </>
  );
};

export default ProfileOfficeFeatures;
